export default {"src":"/_next/static/media/quick.38883b2a.svg","height":61,"width":60};